import { capitalize, defaultsDeep } from 'lodash';
import { RefillFormData } from '../model';
import { fullNameAndTitle } from 'src/utils';
import { Client, Patient } from 'src/interfaces';

export const INITIAL_FORM_DATA: {
  [key in keyof RefillFormData]?: Partial<RefillFormData[key]>;
} = {
  clientInfo: {
    fullName: '',
    phoneNumber: '',
    emailAddress: '',
    acceptConditions: false
  },
  patientInfo: {},
  additionalInfo: {},
  notificationSettings: {}
};

export const getInitialValues = (
  user: Client | undefined,
  patient: Patient | undefined,
  lastSubmittedValues?: Partial<RefillFormData>
): RefillFormData => {
  const apiData = {
    clientInfo: {
      fullName: fullNameAndTitle(user),
      emailAddress: user?.email,
      phoneNumber: user?.mobilePhone ?? user?.homePhone ?? user?.workPhone,
      clientId: user?.clientId
    },
    patientInfo: {
      patientId: patient?.patientId,
      name: patient?.name ? capitalize(patient.name) : undefined,
      breed:
        patient?.breed || patient?.species
          ? capitalize(patient.breed ?? patient.species)
          : undefined,
      age: patient?.birthdate,
      sex: patient?.sex ? capitalize(patient.sex) : undefined,
      isNewPatient: patient ? false : undefined
    }
  };
  return Object.assign(defaultsDeep(apiData, INITIAL_FORM_DATA), lastSubmittedValues);
};
